import store from '@/store';
import { stmHttpClient, httpManager as http } from '@/plugins/HttpManager';
import {
    IAccountDevice,
    ICommonRes,
    TGetUserGalleryListArgs,
    IGetUserGalleryListRes,
    IAlarmType,
    IGetGalleryCalendarByPeriodArgs,
    TGetGalleryCalendarByPeriodRes
} from '../interface/api';
import {
    IDeviceGalleryAlarmType,
    IGetDeviceGalleryAlarmTypeListArgs,
    IGetGalleryAlarmTypeListArgs,
    IGetGalleryAlarmTypeListResponse
} from '@reolink-cloud/interface';
import { objectToQueryString } from '@/common/js/utils';

type TGalleryAlarmTypeRequestArgs =
    Omit<IGetDeviceGalleryAlarmTypeListArgs, 'lang'>
    & Pick<IGetGalleryAlarmTypeListArgs, 'language' | 'role'>;

const requestGalleryAlarmTypeList = async (
    args: TGalleryAlarmTypeRequestArgs
): Promise<IGetGalleryAlarmTypeListResponse> => {

    const { data } = await http.get<IGetGalleryAlarmTypeListResponse>(
        `/cloud/gallery/alarm-types/${objectToQueryString( args )}`
    );
    return data;

};

/**
 * 查询当前用户相册列表
 * @param args
 * @returns
 */
export const getGalleryList =
    async ( args: TGetUserGalleryListArgs ): Promise<IGetUserGalleryListRes> => {

        const { data } = await stmHttpClient.post<IGetUserGalleryListRes>( `/cloud/gallery/items/list-query/`, args, { encryptRequestBody: false });
        // 过滤非本用户的视频
        data.items = data.items.map( gallery => {

            gallery.$helperTip = '';
            gallery.checked = false;
            return gallery;

        }).filter( gallery => parseInt( gallery.ownerId ) === store.state.user.user.id );

        return data;

    };
/**
 * 获取设备上传的录像和图片的所有告警类型
 * @param {IGetDeviceGalleryAlarmTypeListArgs} args
 * @returns
 */
export const getUserDeviceGalleryAlarmTypeList =
    async ( args: IGetDeviceGalleryAlarmTypeListArgs ): Promise<IDeviceGalleryAlarmType[]> => {

        const { lang, ...requestArgs } = args;
        const { items } = await requestGalleryAlarmTypeList({
            ...requestArgs,
            language: lang
        });
        return items;

    };

/**
 * 获取告警类型列表
 * @param lang 当前语言
 * @returns
 */
export const getTotalGalleryAlarmTypeList =
    async ( lang = 'en' ): Promise<IAlarmType[]> => {

        const { data } = await http.get<ICommonRes<IAlarmType>>( `/videos/alarm-types/?lang=${lang}` );

        return data.items;

    };

export const getGalleryAlarmTypeList = async (
    args: IGetGalleryAlarmTypeListArgs
): Promise<IGetGalleryAlarmTypeListResponse> => requestGalleryAlarmTypeList( args );

/**
 * 查询当前用户有录像或者图片的设备
 * @returns
 */
export const getHaveGalleryDevices =
    async (): Promise<Array<{ uid: string; }>> => {

        const { data } = await http.get<ICommonRes<{ uid: IAccountDevice['uid']; }>>( '/cloud/gallery/devices' );

        return data.items;

    };

/**
 * 查询指定时间段内每天/每小时是否有录像\
 * 仅返回有图片的天或者小时偏移量
 * @param args
 * @returns
 */
export const getGalleryCalendar =
    async ( args: IGetGalleryCalendarByPeriodArgs ): Promise<TGetGalleryCalendarByPeriodRes['items']> => {

        const qsArr: string[] = [];
        for ( const key of Object.keys( args )) {

            if ( key === 'uid' ) {

                args['uid']!.map( uid => {

                    qsArr.push( `uid=${uid}` );

                });

            } else {

                qsArr.push( `${key}=${args[key]}` );

            }

        }
        const qs = qsArr.join( '&' );

        const { data } = await http.get<TGetGalleryCalendarByPeriodRes>( `/cloud/gallery/calendar/?${qs}` );

        return data.items;

    };

export const requestGalleryHDImage = async ( uid: string, imageIds: string[]  ): Promise<Array<{ id: string; }>> => {

    const { data } = await http.post<ICommonRes<{ id: string; }>>( `/cloud/images/hd-requests/`, {
        ids: imageIds,
        uid
    });

    return data.items;

};

// export const downloadGalleryItem = async ( videoId: string, encryptedHeaders ) => {

//     const [data, headers] = await Promise.all( [
//         getVideoUrls( 'download', [videoId] ),
//         encryptedHeaders
//     ] );

//     const videoUrl = data.items[0].url;

//     let downloadUrl = videoUrl;

//     let responseContentDisposition;

//     if ( headers ) {

//         responseContentDisposition = getResponseContentDisposition( videoUrl );
//         downloadUrl = await fetchStream( downloadUrl, { headers, timeout: void 0 });

//     }

//     downLoad( downloadUrl, `${videoId}.mp4`, responseContentDisposition );

// };

export const deleteGallery = async ( galleryItemId: string[], type: 'video'|'image' ): Promise<void> =>  {

    let str = '';

    galleryItemId = galleryItemId.map( item => {

        return `id=${type === 'video' ? 'v' : 'i'}${item}`;

    });
    str = galleryItemId.join( '&' );

    await http.delete( `/cloud/gallery/items/?${str}` );

};
